"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const InputBase_1 = require("@mui/material/InputBase");
const MuiInputBaseOverrides = {
    MuiInputBase: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: theme.palette.common.white,
            }),
            inputAdornedStart: {
                [`&.${InputBase_1.inputBaseClasses.input}.drift-text-input`]: {
                    padding: '16px 12px 16px 0',
                    [`&.${InputBase_1.inputBaseClasses.sizeSmall}`]: {
                        padding: '8px 12px 8px 0',
                    },
                },
            },
            input: {
                [`&.${InputBase_1.inputBaseClasses.input}`]: {
                    boxSizing: 'content-box',
                },
                [`&.${InputBase_1.inputBaseClasses.input}.drift-multiline-input`]: {
                    padding: '0',
                },
            },
        },
    },
};
exports.default = MuiInputBaseOverrides;
//# sourceMappingURL=InputBaseOverrides.js.map